import DdSubHeader from '@/components/DdSubHeader'
import DdRadioButton from '@/components/DdRadioButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdTextBox from '@/components/DdTextBox.vue'
import DdCheckbox from '@/components/DdCheckbox.vue'
import DdYearMonthBoxWithSelector from '@/components/DdYearMonthBoxWithSelector.vue'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'
import message from '@/ddv2.library/messages'

export default {
  name: 'SeikyuList',
  mixins: [flowMixin],
  data: () => ({
    selected: [{}],
    expansionPanel: [0, 1],
    conditions: {
      seikyusho: '',
      torihikisakiCd: '',
      seikyuNo: '',
      seikyuYm: '',
      shimeDay: '',
      shiborikomiStartDay: '',
      shiborikomiEndDay: '',
      seikyushoKarihakko: '',
      eigyoshoCd: '',
      seikyuZeroFlg: '',
      shanaiTantoshaCd: ''
    },
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersJininList: header.mstJininHeaders,
    // 表示制御
    dispSeikyusho: '',
    dispSeikyuIchiranHyo: '',
    dispSeikyuIchiranCsv: '',
    modeKengen: 0,
    CancelButtonDisp: false,
    PrintButtonDisp: false,
    page: 1,
    lastShimeYmd: ''
  }),
  components: {
    DdSubHeader,
    DdRadioButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdCheckbox,
    DdTextBox,
    DdYearMonthBoxWithSelector
  },
  computed: {
    ...mapGetters({
      seikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyosho: 'users/eigyoshoCd',
      JininList: 'DDMasters/mstJinin',
      messageList: 'DDMasters/msysMessage',
      systemConfigList: 'DDMasters/msysSystemConfig'
    }),
    filteredSeikyusakiList () {
      // 請求先限定
      const target = filter.dateFormatter(new Date())
      return this.seikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.JininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        if (elem.jininNmSei) { elem.hakkoshaNm = elem.jininNmSei + (elem.jininNmMei ? elem.jininNmMei : '') }
        if (elem.torihikisakiCd) { elem.torihikisakiCdNm = elem.torihikisakiCd + ':' + elem.torihikisakiNm }
        elem.konkaiSeikyuKingaku = filter.numericFormatter(elem.konkaiSeikyuKingaku) + '円'
        elem.kihonUnchiGokei = filter.numericFormatter(elem.kihonUnchiGokei) + '円'
        elem.warimashiKingakuGokei = filter.numericFormatter(elem.warimashiKingakuGokei) + '円'
        elem.kazeiKingakuGokei = filter.numericFormatter(elem.kazeiKingakuGokei) + '円'
        elem.konkaiTax = filter.numericFormatter(elem.konkaiTax) + '円'
        elem.hiwayPriceGokei = filter.numericFormatter(elem.hiwayPriceGokei) + '円'
        elem.uchizeiKingakuGokei = filter.numericFormatter(elem.uchizeiKingakuGokei) + '円'
        elem.hikazeiKingakuGokei = filter.numericFormatter(elem.hikazeiKingakuGokei) + '円'
        if (elem.seikyushoHakkoYmd) { elem.seikyushoHakkoYmd = elem.seikyusho !== '未出力' ? filter.dateYmdHmsFormatter(elem.seikyushoHakkoYmd) : '' }
        if (elem.seikyuYmd) { elem.seikyuYmd = filter.dateFormatter(elem.seikyuYmd) }
        if (elem.nyukinYoteiYmd) { elem.nyukinYoteiYmd = filter.dateFormatter(elem.nyukinYoteiYmd) }
        if (elem.shiborikomiStartYmd || elem.shiborikomiEndYmd) { elem.shiborikomiYmd = filter.dateFormatter(elem.shiborikomiStartYmd) + ' ~ ' + filter.dateFormatter(elem.shiborikomiEndYmd) }
        if (elem.torikeshiJininNmSei) { elem.torikeshishaNm = elem.torikeshiJininNmSei + (elem.torikeshiJininNmMei ? elem.torikeshiJininNmMei : '') }
        if (elem.torikeshiYmd) { elem.torikeshiYmd = filter.dateYmdHmsFormatter(elem.torikeshiYmd) }

        return elem
      })
    },
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isSelected () {
      if (this.selected.length === 0) { return true }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
    this.selected = []
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsttorihikisakigetseikyusaki', 'msteigyosho', 'mstjinin', 'msyssystemconfig'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: '請求書', value: 'seikyusho' },
              { text: '仮発行', value: 'seikyushoKarihakkoFlg', align: 'center' },
              { text: '請求番号', value: 'seikyuNo' },
              { text: '請求先コード/名称', value: 'torihikisakiCdNm' },
              { text: '当月請求額', value: 'konkaiSeikyuKingaku', align: 'right' },
              { text: '(運賃)', value: 'kihonUnchiGokei', align: 'right' },
              { text: '(割増)', value: 'warimashiKingakuGokei', align: 'right' },
              { text: '(その他課税)', value: 'kazeiKingakuGokei', align: 'right' },
              { text: '(消費税)', value: 'konkaiTax', align: 'right' },
              { text: '(高速代)', value: 'hiwayPriceGokei', align: 'right' },
              { text: '(その他内税)', value: 'uchizeiKingakuGokei', align: 'right' },
              { text: '(その他非課税)', value: 'hikazeiKingakuGokei', align: 'right' },
              { text: '発行者', value: 'hakkoshaNm' },
              { text: '発行日', value: 'seikyushoHakkoYmd' },
              { text: '取消者', value: 'torikeshishaNm' },
              { text: '取消日', value: 'torikeshiYmd' },
              { text: '締日', value: 'shimeDay' },
              { text: '請求日', value: 'seikyuYmd' },
              { text: '入金予定日', value: 'nyukinYoteiYmd' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '固有コード1', value: 'userCustomCd1' },
              { text: '固有コード2', value: 'userCustomCd2' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            var today = new Date()
            self.conditions = {
              seikyusho: '01',
              torihikisakiCd: '',
              seikyuNo: '',
              seikyuYm: ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2),
              shimeDay: '',
              shiborikomiStartDay: '',
              shiborikomiEndDay: '',
              seikyushoKarihakko: '01',
              eigyoshoCd: this.usersEigyosho,
              seikyuZeroFlg: '',
              shanaiTantoshaCd: ''
            }
            this.selected = []
            this.CancelButtonDisp = false
            this.PrintButtonDisp = false
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            if (self.modeKengen !== 0) {
              this.PrintButtonDisp = true
            }

            if (self.modeKengen === 2) {
              this.CancelButtonDisp = true
            }

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
      this.getShimeJisseki()
    },
    settingSeikyuYm: function (p) {
      this.conditions.seikyuYm = p
    },
    onSearchButtonClick: function (e) {
      this.clearSummaryMessage()
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/d2bild0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            seikyusho: self.conditions.seikyusho,
            seikyushoKarihakko: self.conditions.seikyushoKarihakko,
            seikyuZeroFlg: self.conditions.seikyuZeroFlg
          }
        }
      }
      this.search(opt)
      this.getShimeJisseki()
      this.selected = []
    },
    onRowClick: function (e) {
      console.log(e)
      if (!this.getSystemConfigInfo()) { return }
      this.Effects.loadStart()
      var param = {
        seikyuId: e.id,
        seikyuNo: e.seikyuNo,
        seikyusho: e.seikyusho,
        seikyuYmd: e.seikyuYmd,
        shimeYm: e.seikyuYm,
        shimeDay: e.shimeDay,
        seikyuShimeDate: e.seikyuShimeDate,
        shiborikomiStartYmd: e.shiborikomiStartYmd,
        shiborikomiEndYmd: e.shiborikomiEndYmd,
        seikyusakiCd: e.torihikisakiCd,
        seikyusakiNm: e.torihikisakiNm,
        eigyoshoCd: e.eigyoshoCd,
        kariHakkoFlg: e.seikyushoKarihakkoFlg,
        seikyuZeroFlg: e.seikyuZeroFlg
      }
      this.transition(0, param)
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.clearSummaryMessage()
      this.dispSeikyuIchiranCsv = `請求一覧_${this.getTimeStamp()}.csv`
      this.HttpClient
        .post('/api/v1/d2bild0010/csvdownload', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      this.Effects.loadStart()
      this.clearSummaryMessage()
      this.dispSeikyuIchiranHyo = `請求一覧表_${this.getTimeStamp()}.pdf`
      this.HttpClient
        .requestFileByPost('/api/v1/d2bild0010/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0007')
          this.Effects.loadComplete()
        })
    },
    onCancelButtonClick: function (e) {
      this.clearSummaryMessage()

      var checkResult = this.checkSelected('出力済')
      if (checkResult !== '') {
        this.setInvalidSummaryMessage('BILE0004')
        return false
      }
      // 仮発行だった場合、エラー
      for (const row of this.selected) {
        if (row.seikyushoKarihakkoFlg !== false) {
          this.setInvalidSummaryMessage('BILE0004')
          return false
        }
      }
      // 請求消込を行ったデータだった場合、エラー
      for (const row of this.selected) {
        if (row.trSeikyuKeshikomiMeisaiId !== null) {
          this.setInvalidSummaryMessage('BILE0006')
          return false
        }
      }
      // 月次確定処理を行ったデータだった場合、エラー
      for (const row of this.selected) {
        if (row.trKessanGetsujiKanriId !== null) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        this.selected = this.removeFilterTable(this.selected)
        this.HttpClient.post('/api/v1/d2bild0010/seikyucancel', this.selected)
          .then((data) => {
            if (data.isValid) {
              this.loadFromCache()
                .then((c) => {
                  this.conditions = c.value.conditions || {}
                  this.onSearchButtonClick()
                })
                .then(() => {
                  this.setInvalidSummaryMessage('COMI0005')
                  // this.Effects.loadComplete()
                })
            } else {
              this.Effects.loadComplete()
              this.setInvalidSummaryMessage(data.summaryMessage)
            }
          })
      })
    },
    onPrintButtonClick: function (karihakkoFlg) {
      var kariFlg = karihakkoFlg
      this.clearSummaryMessage()

      console.log(this.selected)
      var checkResult = this.checkSelected('未出力')
      if (checkResult !== '') {
        if (kariFlg === false) { this.setInvalidSummaryMessage('BILE0002') }
        if (kariFlg === true) { this.setInvalidSummaryMessage('BILE0003') }
        return false
      }
      if (this.lastShimeYmd !== '') {
        if (this.checkShimeJisseki() !== '') {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      this.Effects.loadStart()
      var path = null
      this.removeFilterTable(this.selected)
      let cnt = 0
      this.dispSeikyusho = `請求書_${this.getTimeStamp()}.pdf`
      this.selected.forEach(p => {
        if (!p.seikyushoLayoutKbn && !p.seikyuMeisaishoLayoutKbn) {
          if (kariFlg === false) {
            path = '/api/v1/d2bild0010/createseikyudata'
          } else if (kariFlg === true) {
            path = '/api/v1/d2bild0010/createseikyudatakari'
          }
          return this.HttpClient.post(path, p)
            .then((data) => {
              cnt++
              if (cnt === this.selected.length) {
                this.loadFromCache()
                  .then((c) => {
                    this.conditions = c.value.conditions || {}
                    this.onSearchButtonClick()
                  })
                  .then(() => {
                    if (data.summaryMessage) {
                      data.isValid ? this.setInvalidSummaryMessage('BILE0008') : this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                    } else {
                      this.setInvalidSummaryMessage('BILE0008')
                    }
                    this.Effects.loadComplete()
                  })
              }
            })
        } else {
          if (kariFlg === false) {
            path = '/api/v1/d2bild0010/printbill'
          } else if (kariFlg === true) {
            path = '/api/v1/d2bild0010/printbillkari'
          }
          return this.HttpClient
            .requestFileByPost(path, p).then(data => {
              // aタグにファイル仕込んでClickする処理
              const blob = new Blob([data], { type: 'application/pdf' })
              const elem = document.getElementById('seikyushoDownload')
              elem.href = window.URL.createObjectURL(blob)
              elem.click()

              cnt++
              if (cnt === this.selected.length) {
                this.loadFromCache()
                  .then((c) => {
                    this.conditions = c.value.conditions || {}
                    this.onSearchButtonClick()
                  })
                  .then(() => {
                    this.setInvalidSummaryMessage('COMI0007')
                    this.Effects.loadComplete()
                  })
              }
            })
        }
      })
    },
    onPrintAgainButtonClick: function (e) {
      this.clearSummaryMessage()

      var checkResult = this.checkSelected('出力済')
      if (checkResult !== '') {
        this.setInvalidSummaryMessage('BILE0005')
        return false
      }
      this.Effects.loadStart()
      this.removeFilterTable(this.selected)
      let cnt = 0
      this.dispSeikyusho = `請求書_${this.getTimeStamp()}.pdf`
      this.selected.forEach(p => {
        if (!p.seikyushoLayoutKbn && !p.seikyuMeisaishoLayoutKbn) {
          cnt++
          if (cnt === this.selected.length) {
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('BILE0008')
          }
        } else {
          return this.HttpClient
            .requestFileByPost('/api/v1/d2bild0010/printbillagain', p).then(data => {
            // aタグにファイル仕込んでClickする処理
              const blob = new Blob([data], { type: 'application/pdf' })
              const elem = document.getElementById('seikyushoDownload')
              elem.href = window.URL.createObjectURL(blob)
              elem.click()
              cnt++
              if (cnt === this.selected.length) {
                // 完了処理
                this.Effects.loadComplete()
                this.setInvalidSummaryMessage('COMI0007')
              }
            })
        }
      })
    },
    searchValidate: function () {
      var checkRes1 = this.shimeDayCheck()
      var checkRes2 = this.shiborikomiDateCheck()
      if (!checkRes1 || !checkRes2) { return false }
      if (this.conditions.seikyuYm) {
        if (this.conditions.seikyuYm.length !== 7) {
          this.$refs.seikyuYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0012'))
          return false
        }
      }
      return true
    },
    shimeDayCheck: function () {
      if (this.conditions.shimeDay === '') { return true }
      var shimebi = parseInt(this.conditions.shimeDay)
      if ((shimebi >= 32 && shimebi <= 98) || shimebi === 0) {
        this.$refs.shimeDay[this.Ctrls.SET_INVALID_METHOD](message.get('BILV0001'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      return true
    },
    shiborikomiDateCheck: function () {
      if (this.conditions.shiborikomiStartDay === '' && this.conditions.shiborikomiEndDay === '') {
        return true
      } else if ((this.conditions.shiborikomiStartDay !== null || this.conditions.shiborikomiStartDay !== '' || this.conditions.shiborikomiStartDay !== undefined) && (this.conditions.shiborikomiEndDay !== null || this.conditions.shiborikomiEndDay !== '' || this.conditions.shiborikomiEndDay !== undefined)) {
        if (!this.conditions.seikyuYm) {
          this.$refs.seikyuYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', ['絞込日', '請求年月']))
          this.setInvalidSummaryMessage('COME0012')
          return false
        }
        if (!this.checkDate(this.conditions.seikyuYm, this.conditions.shiborikomiStartDay)) {
          this.$refs.shiborikomiStartDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '絞込日(From)'))
          this.setInvalidSummaryMessage('COME0011')
          return false
        }
        if (!this.checkDate(this.conditions.seikyuYm, this.conditions.shiborikomiEndDay)) {
          this.$refs.shiborikomiEndDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '絞込日(To)'))
          this.setInvalidSummaryMessage('COME0011')
          return false
        }
        if (parseInt(this.conditions.shiborikomiStartDay, 10) > parseInt(this.conditions.shiborikomiEndDay, 10)) {
          this.$refs.shiborikomiStartDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '絞込日(From)', '絞込日(To)'))
          this.$refs.shiborikomiEndDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '絞込日(From)', '絞込日(To)'))
          this.setInvalidSummaryMessage('COME0012')
          return false
        }
      } else if (this.conditions.shiborikomiStartDay === '') {
        this.$refs.shiborikomiStartDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', '絞込日(From)', '絞込日(To)'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      } else if (this.conditions.shiborikomiEndDay === '') {
        this.$refs.shiborikomiEndDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', '絞込日(From)', '絞込日(To)'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      return true
    },
    checkSelected (type) {
      for (const row of this.selected) {
        if (row.seikyusho !== type) { return row.seikyusho }
      }
      return ''
    },
    checkShimeJisseki () {
      for (const row of this.selected) {
        if (row.seikyuYmd <= this.lastShimeYmd) { return row.seikyuYmd }
      }
      return ''
    },
    setSeikyushoColor (seikyusho) {
      if (seikyusho === '取消済') return 'red--text'
      else if (seikyusho === '出力済') return 'blue--text'
    },
    removeFilterTable (data) {
      // 金額項目の','と'円'を削除する
      return data.map((elem) => {
        elem.konkaiSeikyuKingaku = this.removeFilterKingaku(elem.konkaiSeikyuKingaku)
        elem.kihonUnchiGokei = this.removeFilterKingaku(elem.kihonUnchiGokei)
        elem.warimashiKingakuGokei = this.removeFilterKingaku(elem.warimashiKingakuGokei)
        elem.kazeiKingakuGokei = this.removeFilterKingaku(elem.kazeiKingakuGokei)
        elem.konkaiTax = this.removeFilterKingaku(elem.konkaiTax)
        elem.hiwayPriceGokei = this.removeFilterKingaku(elem.hiwayPriceGokei)
        elem.uchizeiKingakuGokei = this.removeFilterKingaku(elem.uchizeiKingakuGokei)
        elem.hikazeiKingakuGokei = this.removeFilterKingaku(elem.hikazeiKingakuGokei)

        return elem
      })
    },
    removeFilterKingaku (dispKingaku) {
      var target = dispKingaku.replace('円', '')
      if (target.length > 3) {
        target = target.replace(/,/g, '')
      }
      return target
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    },
    getSystemConfigInfo: function () {
      var systemConfig = this.systemConfigList.filter((t) => {
        return t.configName === 'seikyu_meisai_shiyo_flg'
      })
      if (systemConfig.length > 0 && systemConfig[0].configValue1 === 'NO') {
        return false
      } else {
        return true
      }
    },
    checkDate: function (seikyuYm, day) {
      var y = ('0000' + seikyuYm.split('/')[0]).slice(-4)
      var targetMonth = ('00' + seikyuYm.split('/')[1]).slice(-2)
      var m = targetMonth - 1
      var d = ('00' + day).slice(-2)
      var date = new Date(y, m, d)
      var resultYear = ('0000' + date.getFullYear()).slice(-4)
      var resultMonth = ('00' + (date.getMonth() + 1)).slice(-2)
      var resultDay = ('00' + date.getDate()).slice(-2)

      console.log(resultYear, resultMonth, resultDay)
      if (resultYear !== y || resultMonth !== targetMonth || resultDay !== d) {
        return false
      }
      return true
    },
    getShimeJisseki: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/TrKessanGetsujiKanri/GetAll')
          .then((data) => {
            if (data.payload) {
              var seikyuShimeList = data.payload.map((elem) => {
                elem.taishoShimeYmd = new Date(elem.taishoYm + '/' + elem.taishoShimeDay)
                return elem
              }).filter(function (elem) {
                return elem.taishoGyomuCd === '01' && elem.delFlg === false
              })
              this.lastShimeYmd = seikyuShimeList.length !== 0 ? filter.dateFormatter(seikyuShimeList[seikyuShimeList.length - 1].taishoShimeYmd) : ''
            }
            resolve()
          })
      })
    }
  }
}
